import AxiosService from '../../../gateway/rest/AxiosService'

class TechnicalUserRestService {
  create(technicalUser: any): Promise<any> {
    return AxiosService.post('/salesforce/techusers', technicalUser)
  }
}

export default new TechnicalUserRestService()
